module.exports = __webpack_public_path__ + "img/logoSR.5d02a204.svg";